import 'bootstrap/dist/css/bootstrap.min.css';
export default function Footer(){
    const year = new Date().getFullYear()
    function scrollToSection(section: string) {
        const el = document.getElementById(section);
        el?.scrollIntoView({ behavior: 'smooth' });
    }
    return(
        <>
        <footer className="site-footer bg-dark text-light">
          <div className="container py-4">
            <div className="row align-items-start">
              <div className="col-12 col-lg-4 mb-3">
                <a className="text-decoration-none" href="/">
                  <h1 className="gradient-text-footer">Tasks</h1>
                </a>
                <p className="mt-2">Crie listas e baixe em PDF.</p>
              </div>
              <div className="col-6 col-lg-4 mb-3">
                <div className="d-flex flex-column footer-links">
                  <a onClick={() => scrollToSection('tutorial')} className="cursor-pointer mb-2">Como usar</a>
                  <a onClick={() => scrollToSection('duvidas')} className="cursor-pointer mb-2">Ajuda</a>
                  <a href="/criar" className="mb-2">Criar lista</a>
                  <a href="/privacidade" className="mb-2">Políticas e privacidade</a>
                </div>
              </div>
              <div className="col-6 col-lg-4 mb-3">
                <div className="d-flex justify-content-lg-end">
                  <a target="__blank" className="text-decoration-none d-flex align-items-center me-3 social" href="https://github.com/leanluizz">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-github" viewBox="0 0 16 16">
                      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"/>
                    </svg>
                  </a>
                  <a target="__blank" className="text-decoration-none d-flex align-items-center me-3 social" href="https://www.linkedin.com/in/leandroluizz/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.16-.018V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                    </svg>
                  </a>
                  <a target="__blank" className="text-decoration-none d-flex align-items-center social" href="https://getbootstrap.com/">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-bootstrap-fill" viewBox="0 0 16 16">
                      <path d="M6.375 7.125V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23zm0 3.762h1.898c1.184 0 1.81-.48 1.81-1.377 0-.885-.65-1.348-1.886-1.348H6.375z"/>
                      <path d="M4.002 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm1.06 12V3.545h3.399c1.587 0 2.543.809 2.543 2.11 0 .884-.65 1.675-1.483 1.816v.1c1.143.117 1.904.931 1.904 2.033 0 1.488-1.084 2.396-2.888 2.396z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="border-top border-secondary mt-3 pt-3">
              <p className="text-lg-end text-center m-0">&copy;Copyright {year}. All rights reserved.</p>
            </div>
          </div>
        </footer>
        </>
    )
}